export const roleOptions = [
  { value: 'administrador', label: 'Administrador' },
  { value: 'cliente', label: 'Cliente' },
  { value: 'vendedor', label: 'Vendedor' },
  { value: 'gerente_comercial', label: 'Gerente comercial' },
];
export const roleManagerOptions = [
  { value: 'cliente', label: 'Cliente' },
  { value: 'vendedor', label: 'Vendedor' },
];

export const roleOptionsCreate = [
  { value: 'administrador', label: 'Administrador' },
  { value: 'vendedor', label: 'Vendedor' },
  { value: 'gerente_comercial', label: 'Gerente comercial' },
];
export const roleManagerOptionsCreate = [
  { value: 'vendedor', label: 'Vendedor' },
];

export const typeOptionsInCatalogs = [
  { value: 'estate', label: 'Inmueble' },
  { value: 'payment_method', label: 'Método de pago' },
];

export const typeRoles = {
  administrador: '/administrador',
  cliente: '/cliente',
  vendedor: '/vendedor',
};

export const typePaymentStatus = [
  { value: 'pagado', label: 'Pagado' },
  { value: 'no_pagado', label: 'No pagado' },
  { value: 'vencido', label: 'Vencido' },
];

export const statusByProspect = [
  { value: 'prospecto', label: 'Prospecto' },
  { value: 'propiedad_asignada', label: 'Propiedad asignada' },
  { value: 'seguimiento_de_venta', label: 'Seguimiento de venta' },
  { value: 'documentacion', label: 'Documentación' },
  { value: 'finalizado', label: 'Finalizado' },
];

export const typesByProspect = [
  { value: 'prospecto', label: 'Prospecto' },
  { value: 'cliente', label: 'Cliente' },
];

export const situationSalesTrackings = [
  { value: 'llamada_telefonica', label: 'Llamada telefónica' },
  { value: 'pre_entrevista', label: 'Pre-entrevista' },
  { value: 'post_entrevista', label: 'Post- entrevista' },
  { value: 'en_calificacion', label: 'En calificación' },
  { value: 'ganado', label: 'Ganado' },
  { value: 'perdido', label: 'Perdido' },
];

export const statusByTicket = [
  { value: 'abierto', label: 'Abierto' },
  { value: 'en_revision', label: 'En revisión' },
  { value: 'cerrado', label: 'Cerrado' },
];

export const validatePaymentStatus = [
  { value: '1', label: 'Conciliado' },
  { value: '0', label: 'No conciliado' },
];

export const contactOptionsForProspect = [
  { value: 'facebook', label: 'Facebook' },
  { value: 'instagram', label: 'Instagram' },
  { value: 'tiktok', label: 'TikTok' },
  { value: 'youtube', label: 'YouTube' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'google_adds', label: 'Google Ads' },
  { value: 'plataformas_inmobiliarias', label: 'Plataformas inmobiliarias' },
  { value: 'prospeccion_asesores', label: 'Prospección asesores' },
  { value: 'inmobiliarias_externas', label: 'Inmobiliarias externas' },
  { value: 'visita_punto_venta', label: 'Visita a punto de venta' },
  { value: 'referido', label: 'Referido' },
];

export const typesOfPaymentSection = [
  { value: 'transferencia', label: 'Transferencia' },
  { value: 'tarjeta_credito', label: 'Tarjeta de crédito' },
  { value: 'tarjeta_debito', label: 'Tarjeta de débito' },
  { value: 'cheque', label: 'Cheque' },
  { value: 'efectivo', label: 'Efectivo' },
];

// Opciones para llenar mas informacion del contrato
export const typesProject = [
  { value: 'terreno', label: 'Terreno' },
  { value: 'departamento', label: 'Departamento' },
];

//Se define la tipificacion de campos en base al tipo de proyecto

export const fieldConfigByType = {
  terreno: {
    labels: {
      reserve: 'Coto', //Coto
      block: 'Manzana', //Manzana
      lot_number: 'Número de lote',
    },
    showMeasurements: true,
  },
  departamento: {
    labels: {
      reserve: 'Torre',
      block: 'Nivel',
      lot_number: 'Número de departamento',
    },
    showMeasurements: false,
  },
};

export const maritalStatus = [
  { value: 'soltero', label: 'Soltero' },
  { value: 'casado', label: 'Casado' }
];

//Se solicitó que se remplace por solo casado y soltero
/*export const maritalStatus = [
  { value: 'soltero', label: 'Soltero' },
  { value: 'casado', label: 'Casado' },
  { value: 'unión_libre', label: 'Unión libre' },
  { value: 'divorciado', label: 'Divorciado' },
  { value: 'viudo', label: 'Viudo' },
];
*/

export const maritalRegime = [
  { value: 'sociedad conyugal', label: 'Sociedad Conyugal' },
  { value: 'separación de bienes', label: 'Separación de Bienes' },
  { value: 'otro', label: 'Sociedad Legal' },
];

export const nationalities = [
  { value: 'alemán', label: 'Alemán' },
  { value: 'argentino', label: 'Argentino' },
  { value: 'boliviano', label: 'Boliviano' },
  { value: 'brasileño', label: 'Brasileño' },
  { value: 'canadiense', label: 'Canadiense' },
  { value: 'chileno', label: 'Chileno' },
  { value: 'chino', label: 'Chino' },
  { value: 'colombiano', label: 'Colombiano' },
  { value: 'coreano', label: 'Coreano' },
  { value: 'español', label: 'Español' },
  { value: 'estadounidense', label: 'Estadounidense' },
  { value: 'francés', label: 'Francés' },
  { value: 'inglés', label: 'Inglés' },
  { value: 'italiano', label: 'Italiano' },
  { value: 'japonés', label: 'Japonés' },
  { value: 'mexicano', label: 'Mexicano' },
  { value: 'peruano', label: 'Peruano' },
  { value: 'portugués', label: 'Portugués' },
  { value: 'uruguayo', label: 'Uruguayo' },
  { value: 'venezolano', label: 'Venezolano' },
];

// Items from Sidebar
// import userIcon from '../static/img/balken/usuarios_BALKEN.png';
import cataloguesIcon from '../static/img/balken/catalogo_BALKEN.svg';
import paymentsIcon from '../static/img/balken/pagos_BALKEN.svg';
import prospectiveIcon from '../static/img/balken/prospectos_BALKEN.svg';
import projectsIcon from '../static/img/balken/proyectos_BALKEN.svg';
import usersIcon from '../static/img/balken/usuarios_BALKEN.svg';
import expedienteIcon from '../static/img/balken/expedientes_BALKEN.svg';
import estatesIcon from '../static/img/balken/inmuebles_BALKEN.svg';
import homeIcon from '../static/img/balken/inicio_BALKEN.svg';
import ticketIcon from '../static/img/balken/aclaraciones_BALKEN.svg';

export const sidebarItems = [
  {
    key: 'dashboard-admin',
    image: homeIcon,
    title: 'Inicio',
    roles: ['administrador', 'gerente_comercial'],
    path: '/dashboard',
  },
  {
    key: 'catalogues',
    image: cataloguesIcon,
    title: 'Catálogos de sistema',
    roles: ['administrador'],
    path: '/catalogos',
  },
  {
    key: 'customerInfo',
    image: expedienteIcon,
    title: 'Expediente',
    roles: ['cliente'],
    path: '/expediente',
  },
  {
    key: 'user-management',
    image: usersIcon,
    title: 'Gestión de usuarios',
    roles: ['administrador', 'gerente_comercial'],
    path: '/gestion-usuarios',
  },
  {
    key: 'projects',
    image: projectsIcon,
    title: 'Proyectos',
    roles: ['administrador'],
    path: '/proyectos',
  },
  {
    key: 'estates',
    image: estatesIcon,
    title: 'Inmuebles',
    roles: ['administrador', 'gerente_comercial'],
    path: '/inmuebles',
  },
  {
    key: 'payments',
    image: paymentsIcon,
    title: 'Pagos',
    roles: ['administrador', 'cliente'],
    path: '/pagos',
  },
  {
    key: 'prospective_expedients',
    image: prospectiveIcon,
    title: 'Expedientes',
    roles: ['administrador'],
    path: '/prospectos',
  },
  {
    key: 'prospective_clients',
    image: prospectiveIcon,
    title: 'Prospección',
    roles: ['vendedor', 'gerente_comercial'],
    items: [
      { key: 'prospects', path: '/prospectos', label: 'Clientes prospectos' },
      { key: 'prospects-create', path: '/seguimiento-venta', label: 'Seguimiento de venta' },
    ],
  },
  {
    key: 'tickets',
    image: ticketIcon,
    title: 'Mesa de ayuda',
    roles: ['administrador', 'cliente'],
    path: '/tickets',
    // items: [
    //   { key: 'prospects-list', path: '/prospectos', label: 'Clientes prospectos' },
    //   { key: 'prospects-create', path: '/seguimiento-venta', label: 'Seguimiento de venta' },
    // ],
  },
];
